import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import I18NextHttpBackend from "i18next-http-backend";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import { browserLanguageDetected, languageChanged } from "./model";
export var locales = {
    namespaces: {
        shared: "shared",
        guest: "guest",
        business: {
            owner: "business/owner",
        },
        rightholder: "rightholder",
    },
};
i18next
    .use(initReactI18next)
    .use(I18NextHttpBackend)
    .use(I18nextBrowserLanguageDetector)
    .init({
    debug: process.env.NODE_ENV !== "production",
    fallbackLng: "ru",
    supportedLngs: ["ru", "en"],
    ns: [locales.namespaces.shared],
    backend: {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: false,
    },
    detection: {},
});
i18next.on("languageChanged", function (lng) {
    return browserLanguageDetected(lng);
});
languageChanged.watch(function (lng) { return i18next.changeLanguage(lng); });
